import api from './api';

/**
 * Servicio para gestión de partidos
 */
class PartidoService {
  
  /**
   * Actualizar la hora (y opcionalmente fecha) de un partido
   * @param {number} partidoId - ID del partido
   * @param {Object} data - Datos a actualizar
   * @param {string} data.hora - Nueva hora del partido (formato HH:MM o HH:MM:SS)
   * @param {string} [data.fecha] - Fecha específica YYYY-MM-DD (solo sedes con jornada de 2 días). Null = hereda jornada.fecha
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async updateHoraPartido(partidoId, data) {
    try {
      console.log(`🔄 Actualizando hora del partido ${partidoId}:`, data);
      
      const response = await api.put(`/partidos/${partidoId}/hora`, data);
      
      console.log('✅ Respuesta actualización hora partido:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al actualizar hora del partido:', error);
      throw error;
    }
  }

  /**
   * Asignar o cambiar el campo (instalación física) de un partido (C-01 multi-campo)
   * @param {number} partidoId - ID del partido
   * @param {number|null} campoId - ID del campo, o null para quitar asignación
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async updateCampoPartido(partidoId, campoId) {
    const response = await api.put(`/partidos/${partidoId}/campo`, { campo_id: campoId });
    return response.data;
  }

  /**
   * Obtener información de un partido específico
   * @param {number} partidoId - ID del partido
   * @returns {Promise<Object>} Información del partido
   */
  async getPartido(partidoId) {
    try {
      console.log(`📋 Obteniendo información del partido ${partidoId}`);
      
      const response = await api.get(`/partidos/${partidoId}`);
      
      console.log('✅ Información del partido obtenida:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener información del partido:', error);
      throw error;
    }
  }

  /**
   * Obtener futbolistas inscritos en un partido
   * @param {number} partidoId - ID del partido
   * @returns {Promise<Object>} Lista de futbolistas del partido
   */
  async getFutbolistasPartido(partidoId) {
    try {
      console.log(`👥 Obteniendo futbolistas del partido ${partidoId}`);
      
      const response = await api.get(`/partidos/${partidoId}/futbolistas`);
      
      console.log('✅ Futbolistas del partido obtenidos:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener futbolistas del partido:', error);
      throw error;
    }
  }

  /**
   * Enviar notificaciones de cambio de hora a futbolistas del partido
   * @param {number} partidoId - ID del partido
   * @param {Object} cambioInfo - Información del cambio
   * @returns {Promise<Object>} Resultado del envío de notificaciones
   */
  async enviarNotificacionesCambioHora(partidoId, cambioInfo) {
    try {
      console.log(`📧 Enviando notificaciones de cambio de hora para partido ${partidoId}:`, cambioInfo);

      const response = await api.post(`/partidos/${partidoId}/notificar-cambio-hora`, cambioInfo);

      console.log('✅ Notificaciones enviadas:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al enviar notificaciones:', error);
      throw error;
    }
  }

  /**
   * Obtener estado de notificaciones de horario de un partido
   * @param {number} partidoId - ID del partido
   * @returns {Promise<Object>} Estado de notificaciones
   */
  async getNotificacionesHorarioPartido(partidoId) {
    try {
      console.log(`🔔 Obteniendo estado de notificaciones para partido ${partidoId}`);

      const response = await api.get(`/partidos/${partidoId}/notificaciones-horario`);

      console.log('✅ Estado de notificaciones obtenido:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener estado de notificaciones:', error);
      throw error;
    }
  }

  /**
   * Obtener futbolistas que NO han sido notificados sobre el horario del partido
   * @param {number} partidoId - ID del partido
   * @returns {Promise<Object>} Lista de futbolistas no notificados
   */
  async getFutbolistasNoNotificados(partidoId) {
    try {
      console.log(`🔍 Obteniendo futbolistas no notificados para partido ${partidoId}`);

      const response = await api.get(`/partidos/${partidoId}/futbolistas-no-notificados`);

      console.log('✅ Futbolistas no notificados obtenidos:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener futbolistas no notificados:', error);
      throw error;
    }
  }

  /**
   * Reenviar notificaciones solo a futbolistas no notificados
   * @param {number} partidoId - ID del partido
   * @param {Array} excluirFutbolistas - IDs de futbolistas a excluir
   * @returns {Promise<Object>} Resultado del reenvío
   */
  async reenviarNotificacionesSelectivas(partidoId, excluirFutbolistas = []) {
    try {
      console.log(`📧 Reenviando notificaciones selectivas para partido ${partidoId}`);
      console.log(`🚫 Excluyendo ${excluirFutbolistas.length} futbolistas`);

      const response = await api.post(`/partidos/${partidoId}/reenviar-notificaciones`, {
        excluir_futbolistas: excluirFutbolistas
      });

      console.log('✅ Notificaciones reenviadas:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error al reenviar notificaciones:', error);
      throw error;
    }
  }
}

export default new PartidoService();
